@if (hasAccess) {
<div class="container-fluid p-4 d-flex flex-column flex-grow-1 overflow-hidden">
  <div class="row">
    <div class="col">
      @if (schedulingMode) {
        <div class="mb-3">
          <!--
            MOD-3651: the panel owns its foreman list and per-row availability —
            fetched against opportunity.job.branchId (the project's branch), not
            the calendar's selection. Monthly Capacity passes no foreman data.
          -->
          <app-schedule-project-panel
            [opportunityId]="opportunityId ?? ''"
            [projectId]="projectId ?? ''"
            [branchId]="selectedBranch?.id"
            [initialInstallDates]="panelInstallDates"
            [crewsLoading]="isLoading || crewGroups === null"
            [customerSatisfactionVisit]="customerSatisfactionVisit"
            (saved)="onPanelSaved()"
            (exitEditMode)="onPanelExitEditMode()"
            (goBackToJob)="onPanelGoBackToJob()"
            (dateRemoved)="onPanelDateRemoved($event)"
            (projectChanged)="onPanelProjectChanged($event)" />
        </div>
      }
      <app-monthly-capacity-metrics [hidden]="schedulingMode" [selectedBranch]="selectedBranch" [startDate]="startDate"
        [endDate]="endDate" [paused]="schedulingMode" />
    </div>
  </div>
  <div class="row flex-grow-1">
    <div class="col d-flex flex-column">
      <app-side-modal />
      <groundworks-legend [items]="legendItems" />
      <groundworks-capacity-calendar [crewGroups]="crewGroups" [isLoading]="isLoading" [isError]="isError"
        [capabilityDisplay]="'canInstall'" [startDate]="initialDate"
        [firstAvailableInstallDate]="schedulingMode ? today : null"
        [sectionOrder]="sectionOrder"
        (capacityClicked)="onDayClicked($event)" (dateHeaderClicked)="onDateHeaderClicked($event)"
        (settingsClicked)="onSettings()" (selectionChanged)="onSelectionChanged($event)"
        (calendarViewChange)="onCalendarViewChanged($event)"
      />
    </div>
  </div>
</div>
} @else {
<div data-testid="unauthorized-message" class="container-fluid p-4">
  <div class="alert alert-warning" role="alert">
    You do not have permission to view this page.
  </div>
</div>
}
